import { useEffect, useState } from 'react'
import { formatCountdown, msUntil } from '@/lib/time'

/* Counts down to first kickoff — not to Thursday. Week 18 has no Thursday game,
   Thanksgiving week has a Friday one, and a Wednesday Christmas has happened.
   The value comes from weeks.picks_lock_at, which the DB keeps as the earliest
   kickoff in the week via a one-way ratchet trigger. */
export default function LockCountdown({ locksAt }: { locksAt: string | null }) {
  const [ms, setMs] = useState(() => (locksAt ? msUntil(locksAt) : 0))

  useEffect(() => {
    if (!locksAt) return
    const id = setInterval(() => setMs(msUntil(locksAt)), 1000)
    return () => clearInterval(id)
  }, [locksAt])

  if (!locksAt) return <span className="eyebrow">Schedule pending</span>

  if (ms <= 0) {
    return (
      <span className="text-flag font-mono text-eyebrow tracking-[0.16em] uppercase">
        Picks closed
      </span>
    )
  }

  return (
    <span className="text-mark font-mono text-eyebrow tracking-[0.14em] tabular-nums">
      {formatCountdown(ms)}
    </span>
  )
}
